import { render, staticRenderFns } from "./PageReportDropdown.vue?vue&type=template&id=2f5ede12&scoped=true&"
import script from "./PageReportDropdown.vue?vue&type=script&lang=js&"
export * from "./PageReportDropdown.vue?vue&type=script&lang=js&"
import style0 from "./PageReportDropdown.vue?vue&type=style&index=0&id=2f5ede12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5ede12",
  null
  
)

export default component.exports